import type { FC } from 'react'
import * as Yup from 'yup'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

import { TextFieldInput, TextFieldInputProps } from './TextFieldInput.js'

export const EmailInput: FC<TextFieldInputProps> = ({ name, ...props }) => {
  const { t } = useTranslation()

  return <TextFieldInput {...props} name={name} type="email" label={t('inputs.emailInput.emailLabel')} />
}

export const createEmailValidationSchema = (
  t: TFunction
): Yup.StringSchema<string, Yup.AnyObject, string, Yup.ToggleDefault<'', string>> =>
  Yup.string()
    .required(t('inputs.emailInput.emailIsRequiredErrorMessage'))
    .email(t('inputs.emailInput.emailIsInvalidErrorMessage'))
    .default('')
